import React from 'react'
import Carousel from 'react-material-ui-carousel'
import { Paper, Typography, withStyles } from '@material-ui/core'

// import Authority from '../assets/AuthorityMagazine.png';
import Authority from '../assets/Authority.png';
import Thrive from '../assets/ThriveGlobal.png';
// import Story from '../assets/StoryToday.png';
import Story from '../assets/Story.png';
import Hatch from '../assets/Hatch.png'
import styles from '../config/styles'


function Item(props) {
    return (
        <Paper>
            <a href={props.item.url} target='_blank' rel="noopener noreferrer">

                <img src={props.item.image} width='100%' height='auto' alt='site' />
            </a>
        </Paper>
    )
}

const Articles = (props) => {
    const { classes } = props
    const articles = [
        {
            image: Authority,
            url: 'https://medium.com/authority-magazine/meet-the-disruptors-goutham-gandhi-nadendla-of-riku-on-the-three-things-you-need-to-shake-up-e2b5006ec4ea'
        },
        {
            image: Story,
            url: 'https://www.storytoday.co.in/riku-automatic-curry-and-rice-maker/'
        },
        {
            image: Thrive,
            url: 'https://thriveglobal.com/stories/goutham-gandhi-nadendla-of-riku-anything-worth-doing-is-worth-doing-well/'
        }, {
            image: Hatch,
            url: 'https://www.projecthatch.co/interview/creating-a-machine-for-effortless-home-cooking-experience/'
        }
    ]

    return (
        <div style={{ width: '100%', height: '100%', backgroundColor: "#f6f6f6", }}>

            <div className={[classes.articles, ].join(",")} >
                <div className={classes.innerHeaderSection}>
                <Typography variant="h4">
                    In The Press
                </Typography>
                </div>
                <Carousel >
                    {articles.map((article, index) => <Item key={index} item={article} />)}
                </Carousel>
            </div>
        </div>
    )
}


export default withStyles(styles)(Articles)